export default __webpack_public_path__ + "static/media/446.73ae690e.jpg";